import React from 'react';
import AdminPageHolder from '../AdminPanelsPage/AdminPageHolder';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import SocialDashboard from './SocialDashboard';
import { parse } from '../../util/urlHelpers';
import { isValidSocialPostsRouteTab, loadData } from './AdminSocialPostsPage.duck';

/**
 * Admin dashboard for the AI social-media automation: the single place to review
 * pending drafts, browse history, edit the prompt/email templates, and toggle
 * the engine. Gated by `administrator` role via AdminPageHolder (adminPageHOC).
 *
 * Data lives in the AdminSocialPostsPage duck; AdminPageHolder clones children
 * with `currentUser` + `history`, and SocialDashboard connects to the store.
 */
const AdminSocialPostsPage = props => {
    const { tab } = parse((props.location && props.location.search) || '');
    if (!isValidSocialPostsRouteTab(tab)) return <NotFoundPage />;

    return (
        <AdminPageHolder
            title="AdminSocialPostsPage"
            schema={{
                '@context': 'http://schema.org',
                '@type': 'AdminSocialPostsPage',
                description: 'Social media automation',
                name: 'Admin panel',
            }}
        >
            <SocialDashboard />
        </AdminPageHolder>
    );
};

AdminSocialPostsPage.loadData = loadData;

export default AdminSocialPostsPage;
